(function() {
    'use strict';
    angular
        .module('cbl.finanza.mf.directives')
        .directive('finDossierComposition', [
            '$filter',
            'FinDossierCompositionSrvc',
            'uiGridConstants',
            'uiGridGroupingConstants',
            'CommonUtilitiesSrvc',
            'FinDeskSrvc',
            'FIN_CONSTANTS',
            function(
                $filter,
                finDossierCompositionSrvc,
                uiGridConstants,
                uiGridGroupingConstants,
                commonUtilities,
                deskSrvc,
                CONSTANTS
            ) {
                var directiveImpl = function($scope) {
                    $scope.service = finDossierCompositionSrvc;
                    $scope.commonUtilities = commonUtilities;

                    if (!$scope.dossierDivisa) {
                        $scope.dossierDivisa = 'EUR';
                    }

                    if (!$scope.dossierCambio) {
                        $scope.dossierCambio = 1;
                    }

                    if (!$scope.dossierDecimali) {
                        $scope.dossierDecimali = 2;
                    }

                    $scope.spinner = $scope.commonUtilities.getSpinnerStyle($scope);

                    if ($scope.numeroRapporto && $scope.numeroRapporto.length < 6) {
                        var leftPadding = 6 - $scope.numeroRapporto.length;
                        for (var index = 0; index < leftPadding; index++) {
                            $scope.numeroRapporto = '0' + $scope.numeroRapporto;
                        }
                    }

                    $scope.formCompositionReset = function() {
                        $scope.service.inputCompositionForm = {
                            startDate: null,
                            isRaggruppaDerivati: false
                        };
                        $scope.service.datasource = null;
                    };

                    $scope.service.views.defaultView = {
                        title: 'Composizione',
                        url: CONSTANTS.BASE_ROOT +
                            'widgets/finDossierComposition/states/finDossierComposition.states.table.html',
                        visible: true,
                        searchEnabled: true,
                        type: 'TABLE'
                    };
                    $scope.service.groups.defaultGroup = {
                        title: 'Nessuno (per Isin)',
                        field: 'CodiceIsin',
                        grouping: false,
                        row: 2,
                        graph: false
                    };

                    $scope.setToday = function() {
                        if ($scope.service.inputCompositionForm.isRaggruppaDerivati) {
                            $scope.service.inputCompositionForm.startDate = new Date();
                        }
                    };

                    $scope.detectGroupingCellContent = function(row, col) {
                        var flag = !col.grouping ||
                            col.grouping.groupPriority === undefined ||
                            col.grouping.groupPriority === null ||
                            (row.groupHeader && col.grouping.groupPriority === row.treeLevel);
                        return flag;
                    };

                    // Costruzione della tabella ui-grid
                    var gridColumns = [
                        { name: 'Isin', field: 'CodiceIsin' },
                        { name: 'Tipologia', field: 'Tipologia' },
                        { name: 'Descrizione', field: 'Descrizione', width: '15%' },
                        {
                            name: 'Intestatario',
                            field: 'Intestatario',
                            visible: true,
                            width: '10%'
                        },
                        { name: 'Divisa', field: 'DivisaQuotazione', width: '5%' },
                        {
                            name: "Qta' disp.",
                            field: 'quantitaDisponibile',
                            cellFilter: 'number: 6',
                            cellClass: 'right'
                        },
                        {
                            name: "Qta'",
                            field: 'quantita',
                            cellFilter: 'number: 6',
                            cellClass: 'right'
                        },
                        {
                            name: 'Ctv (' + $scope.dossierDivisa + ')',
                            field: 'Controvalore',
                            cellClass: 'right',
                            cellFilter: 'number: 2',
                            cellTemplate: '<div ng-if="grid.appScope.detectGroupingCellContent(row, col)" class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div>',
                            customTreeAggregationFinalizerFn: function(aggregation) {
                                aggregation.rendered = aggregation.value;
                            }
                        },
                        {
                            name: 'Rateo (' + $scope.dossierDivisa + ')',
                            field: 'RateoMercato',
                            cellFilter: 'number: 2',
                            cellClass: 'right',
                            cellTemplate: '<div ng-if="grid.appScope.detectGroupingCellContent(row, col)" class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div>',
                            customTreeAggregationFinalizerFn: function(aggregation) {
                                aggregation.rendered = aggregation.value;
                            }
                        },
                        {
                            name: 'Prz Merc.',
                            field: 'PrezzoMercato',
                            cellFilter: 'number: 5',
                            cellClass: 'right'
                        },
                        {
                            name: 'Prz Med.',
                            field: 'PrezzoMedioCarico',
                            cellFilter: 'number: 5',
                            cellClass: 'right'
                        },
                        {
                            name: 'Plus/Minus (%)',
                            field: 'PercPlusMinValenza',
                            cellFilter: 'number: 3',
                            cellClass: 'right'
                        },
                        {
                            name: 'Plus/Minus (Eur)',
                            field: 'ImportoPlusMinValenza',
                            cellFilter: 'number: 2',
                            visible: false
                        },
                        {
                            name: 'Cambio di mercato',
                            field: 'CambioMercato',
                            cellFilter: 'number: 2',
                            visible: false
                        },
                        {
                            name: 'Data prezzo di mercato',
                            field: 'DataPrezzoMercato',
                            cellFilter: 'date:"dd/MM/yyyy"',
                            visible: false
                        },
                        {
                            name: 'Cambio medio di carico',
                            field: 'CambioCarico',
                            cellFilter: 'number: 5',
                            visible: false
                        },
                        {
                            name: 'ClasseRischioComplessita',
                            field: 'ClasseRischioComplessita',
                            visible: false
                        },
                        {
                            name: 'ClasseRischioEmittente',
                            field: 'ClasseRischioEmittente',
                            visible: false
                        },
                        {
                            name: 'ClasseRischioMercato',
                            field: 'ClasseRischioMercato',
                            visible: false
                        }
                    ];
                    var defaultGrouping = { groupPriority: 0 };
                    var defaultSort = { priority: 0, direction: 'asc' };

                    // Customizzazione dei raggruppamenti: in caso di valore NULL nella colonna il raggruppamento restituisce NON SPECIFICATO
                    var setGroupValues = function(columns, rows) {
                        columns.forEach(function(column) {
                            if (column.grouping && column.grouping.groupPriority > -1) {
                                column.customTreeAggregationFinalizerFn = function(
                                    aggregation
                                ) {
                                    if (typeof aggregation.groupVal !== 'undefined') {
                                        var label = aggregation.groupVal;
                                        if (label === 'Null') label = 'NON SPECIFICATO';
                                        aggregation.rendered =
                                            label + ' (' + aggregation.value + ')';
                                    } else {
                                        aggregation.rendered = null;
                                    }
                                };
                            }
                        });
                        return columns;
                    };

                    var filter = $filter;

                    $scope.service.gridComposizioneProdottoOptions = {
                        enableSorting: true,
                        enableColumnMenus: false,
                        enableFiltering: true,
                        enableCellEditing: false,
                        enableCellEditOnFocus: false,

                        enableGridMenu: true,
                        gridMenuShowHideColumns: false,
                        exporterCsvFilename: 'ComposizioneDossier.csv',
                        exporterCsvColumnSeparator: ';',
                        exporterFieldCallback: function(grid, row, col, value) {
                            if (col.cellFilter) {
                                var filterSplit = col.cellFilter.split(':');
                                var typeFilter = filterSplit[0].trim();
                                var argFilter =
                                    filterSplit.length < 2 ?
                                    '' :
                                    filterSplit[1].trim().replace(new RegExp(/"/g), '');
                                var result = $filter(typeFilter)(value, argFilter);
                                return result;
                            }
                            return value;
                        },
                        exporterHeaderFilterUseName: true,
                        exporterHeaderFilter: function(name) {
                            return name.toUpperCase();
                        },
                        exporterMenuPdf: false,

                        enableColumnResizing: true,

                        showGridFooter: true,
                        enablePagination: true,
                        paginationPageSizes: [10, 25, 50, 100],
                        paginationPageSize: 10,
                        paginationCurrentPage: 1,

                        enableRowSelection: true,
                        multiSelect: false,
                        enableRowHeaderSelection: false,

                        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                        //enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,

                        onRegisterApi: function(gridApi) {
                            $scope.service.gridApi = gridApi;

                            // Attivo la customizzazione del rendered dei raggruppamenti
                            $scope.service.gridApi.grid.registerColumnsProcessor(
                                setGroupValues,
                                410
                            );

                            $scope.service.gridApi.grouping.on.groupingChanged(
                                $scope,
                                function(column) {
                                    if (column.grouping.groupPriority === undefined) {
                                        column.unsort();
                                    }
                                }
                            );

                            $scope.service.gridApi.selection.on.rowSelectionChanged(
                                $scope,
                                function(row) {
                                    $scope.showDetails(row.entity);
                                }
                            );
                        },

                        columnDefs: gridColumns,
                        data: $scope.service.datasource
                    };
                    commonUtilities.calculateHeightUIGridComponent(
                        $scope.service.gridComposizioneProdottoOptions
                    );

                    // Legge dal servizio tutti gli elementi da visualizzare
                    $scope.getCompositionItems = function() {
                        this.service.searchInProgress = true;

                        var startDate = Date.parse(
                            $scope.service.inputCompositionForm.startDate
                        );
                        var includiDerivati =
                            $scope.service.inputCompositionForm.isRaggruppaDerivati;

                        var serviceUrl = CONSTANTS.REST_ROOT + CONSTANTS.REST.COMPOSIZIONE;
                        var serviceParams = {
                            rapporto: $scope.numeroRapporto,
                            dataSaldo: new Date(startDate),
                            includiDerivati: $scope.derivatiVisible ?
                                includiDerivati :
                                $scope.derivatiDefault
                        };
                        var successCallback = function(data) {
                            $scope.datasource = $scope.service.remapComposition(
                                data.data.composizione
                            );
                            $scope.controvaloreComposizione = data.data.controvalore;

                            if (data.data !== null) {
                                // Inizializzo le sorgenti
                                $scope.service.datasource = $scope.service.remapComposition(
                                    data.data.composizione
                                );
                                if ($scope.service.datasource) {
                                    $scope.service.datasource.forEach(function(data) {
                                        data.Controvalore =
                                            data.Controvalore * $scope.dossierCambio;
                                        data.RateoMercato =
                                            data.RateoMercato * $scope.dossierCambio;
                                    });
                                    $scope.service.controvaloreComposizione =
                                        data.data.controvalore;
                                    $scope.service.gridComposizioneProdottoOptions.data =
                                        $scope.service.datasource;
                                    commonUtilities.calculateHeightUIGridComponent(
                                        $scope.service.gridComposizioneProdottoOptions
                                    );

                                    $scope.getSourceChart();
                                    $scope.service.searchInProgress = false;
                                }
                            }
                        };
                        var errorCallback = function() {
                            $scope.datasource = null;
                            $scope.service.searchInProgress = false;
                        };
                        $scope.service.callComposition(
                            serviceUrl,
                            serviceParams,
                            successCallback,
                            errorCallback
                        );
                    };

                    // Determina se ci sono elementi
                    $scope.hasItems = function() {
                        if (
                            $scope.service.datasource === null ||
                            $scope.service.datasource === undefined
                        ) {
                            return false;
                        }
                        var count = $scope.service.datasource.length;
                        if (count === null || count === undefined) {
                            return false;
                        }
                        var flag = count > 0;
                        return flag;
                    };

                    // #region Funzioni per la gestione delle viste

                    $scope.isActiveView = function(viewUrl) {
                        return viewUrl == $scope.service.views.defaultView.url;
                    };

                    $scope.changeView = function(view) {
                        $scope.service.views.defaultView = view;
                    };

                    $scope.showDetails = function(item) {
                        $scope.service.views.defaultView = $scope.service.views.listView[2];
                        $scope.service.currentItem = item;
                    };

                    $scope.backToTable = function() {
                        $scope.service.views.defaultView = $scope.service.views.listView[0];
                        $scope.service.currentItem = null;
                    };

                    // #endregion

                    // #region Funzioni per la gestione dei gruppi

                    $scope.isActiveGroup = function(groupField) {
                        return groupField == $scope.service.groups.defaultGroup.field;
                    };

                    // Cambia il raggruppamento delle righe
                    $scope.changeGroup = function(group) {
                        $scope.backToTable();
                        $scope.service.groups.defaultGroup = group;

                        if ($scope.hasItems()) {
                            $scope.groupBy(group);
                        }
                    };

                    // Effettua il raggruppamento delle righe
                    $scope.groupBy = function(group) {
                        $scope.service.gridApi.grouping.clearGrouping();
                        if (group.grouping) {
                            $scope.service.gridApi.grouping.groupColumn(group.grouping);
                            $scope.service.gridApi.grouping.aggregateColumn(
                                'Ctv (' + $scope.dossierDivisa + ')',
                                uiGridGroupingConstants.aggregation.SUM
                            );
                            $scope.service.gridApi.grouping.aggregateColumn(
                                'Rateo (' + $scope.dossierDivisa + ')',
                                uiGridGroupingConstants.aggregation.SUM
                            );

                            gridColumns.forEach(function(element, index, array) {
                                if (element.name === group.grouping) {
                                    element.grouping = defaultGrouping;
                                    element.sort = defaultSort;
                                } else {
                                    delete element.grouping;
                                    delete element.sort;
                                }
                            });

                            $scope.service.gridComposizioneProdottoOptions.columnDefs =
                                gridColumns;
                            //$scope.service.gridApi.core.queueGridRefresh();
                            $scope.service.gridApi.core.refresh();
                        }

                        $scope.getSourceChart();
                    };

                    // #endregion

                    // Costruzione del datasource del grafico
                    $scope.getSourceChart = function() {
                        var group = $scope.service.groups.defaultGroup;
                        $scope.service.datasourceChart = [];
                        if (!group.graph) {
                            return;
                        }

                        // Raggruppo in base al campo selezionato e genero il datasource per il grafico
                        // - Passo 1: estraggo le chiavi
                        var flags = {};
                        var keys = {};
                        var length = $scope.service.datasource.length;
                        var currentField = group.field;
                        for (var index = 0; index < length; index++) {
                            var fieldName = $scope.service.datasource[index][currentField];
                            var fieldValue = $scope.service.datasource[index].Controvalore;

                            if (flags[fieldName]) {
                                keys[fieldName] =
                                    keys[fieldName] + new Number(fieldValue).valueOf();
                            } else {
                                flags[fieldName] = true;
                                keys[fieldName] = new Number(fieldValue).valueOf();
                            }
                        }
                        //console.log(JSON.stringify(keys));

                        // - Passo 2: inizializzo il datasource del grafico
                        for (var key in keys) {
                            var segment = {
                                name: key === 'null' ? 'NON SPECIFICATO' : key,
                                y: keys[key]
                            };
                            $scope.service.datasourceChart.push(segment);
                        }
                        //console.log(JSON.stringify($scope.service.datasourceChart));
                    };

                    $scope.exportTableToCSV = function() {
                        var dataCSV = [];
                        // Elimino i campi di angular (quelli che iniziano per $)
                        for (var index in $scope.service.datasource) {
                            var element = $scope.service.datasource[index];
                            var current = {};
                            for (var item in element) {
                                if (item.indexOf('$') !== 0) {
                                    current[item] = element[item];
                                }
                            }
                            dataCSV.push(current);
                        }
                        commonUtilities.downloadCSV(dataCSV, 'export-composizione.csv');
                    };

                    $scope.init = (function() {
                        if (
                            (!$scope.hasItems() &&
                                $scope.service.inputCompositionForm.startDate === null) ||
                            $scope.service.numeroRapporto !== $scope.numeroRapporto
                        ) {
                            $scope.service.inputCompositionForm.startDate = new Date();
                            $scope.service.views.defaultView =
                                $scope.service.views.listView[0];
                            $scope.service.groups.defaultGroup =
                                $scope.service.groups.listGroup[
                                    $scope.service.groups.listGroup.length - 1
                                ];
                            $scope.service.currentItem = null;
                            $scope.getCompositionItems();
                            $scope.service.numeroRapporto = $scope.numeroRapporto;
                        }
                    })();
                };
                directiveImpl.$inject = ['$scope'];

                return {
                    restrict: 'E',
                    scope: {
                        numeroRapporto: '=?numeroRapporto',
                        derivatiVisible: '=?derivatiVisible',
                        derivatiDefault: '=?derivatiDefault',
                        dossierCambio: '=?',
                        dossierDivisa: '=?',
                        dossierDecimali: '=?'
                    },
                    templateUrl: CONSTANTS.BASE_ROOT +
                        'widgets/finDossierComposition/finDossierComposition.html',
                    replace: false,
                    controller: directiveImpl
                };
            }
        ]);
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finDossierComposition/finDossierCompositionDrct.js
 ** module id = 32
 ** module chunks = 1 2
 **/